import { __assign, __rest } from 'tslib';
import React, { useReducer, useCallback, useMemo } from 'react';
import { WizardFormNavItem } from './NavItem.esm.js';

function defaultReducer(state, action) {
    switch (action.type) {
        case "submitStep": {
            var _a = action.payload, index_1 = _a.index, values_1 = _a.values;
            var activeIndex = state.steps[index_1 + 1] ? index_1 + 1 : index_1;
            var steps = state.steps.map(function (step, i) {
                // The step being submitted
                if (i === index_1) {
                    return __assign(__assign({}, step), { disabled: false, hasBeenSubmitted: true, status: "valid", values: values_1 });
                }
                // The next step
                if (i === index_1 + 1) {
                    return __assign(__assign({}, step), { disabled: false });
                }
                return step;
            });
            return __assign(__assign({}, state), { activeIndex: activeIndex, isDirty: true, steps: steps });
        }
        case "gotoStep": {
            var activeIndex = action.payload.next;
            var currentStep = action.payload.currentStep;
            if (currentStep) {
                var index_2 = currentStep.index, stateUpdate_1 = __rest(currentStep, ["index"]);
                var steps = state.steps.map(function (step, i) {
                    if (i === index_2) {
                        return __assign(__assign({}, step), stateUpdate_1);
                    }
                    return step;
                });
                return __assign(__assign({}, state), { activeIndex: activeIndex, steps: steps });
            }
            /* istanbul ignore next */
            return __assign(__assign({}, state), { activeIndex: activeIndex });
        }
        case "statusUpdate": {
            var _b = action.payload, index_3 = _b.index, status_1 = _b.status;
            return __assign(__assign({}, state), { steps: state.steps.map(function (step, i) {
                    if (i === index_3) {
                        return __assign(__assign({}, step), { status: status_1 });
                    }
                    else if (i > index_3) {
                        if (status_1 === "error") {
                            return __assign(__assign({}, step), { disabled: true });
                        }
                        else if (status_1 === "valid" &&
                            state.steps[Math.max(i - 1, 0)].hasBeenSubmitted) {
                            return __assign(__assign({}, step), { disabled: false });
                        }
                    }
                    return step;
                }) });
        }
        /* istanbul ignore next Should be unreachable */
        default:
            return state;
    }
}
function useWizardState(_a) {
    var initialState = _a.initialState, _b = _a.reducer, reducer = _b === void 0 ? defaultReducer : _b;
    var _c = useReducer(reducer, initialState), state = _c[0], dispatch = _c[1];
    var gotoStep = useCallback(function (payload) { return dispatch({ type: "gotoStep", payload: payload }); }, []);
    var statusUpdate = useCallback(function (payload) {
        return dispatch({ type: "statusUpdate", payload: payload });
    }, []);
    var submitStep = useCallback(function (payload) { return dispatch({ type: "submitStep", payload: payload }); }, []);
    var navItems = useMemo(function () {
        return state.steps.map(function (_a, index) {
            var disabled = _a.disabled, hasBeenSubmitted = _a.hasBeenSubmitted, key = _a.key, label = _a.label, status = _a.status;
            return (React.createElement(WizardFormNavItem, { key: key, disabled: disabled, isActive: index === state.activeIndex, onClick: function (currentStepState) {
                    gotoStep({
                        next: index,
                        currentStep: __assign({ index: state.activeIndex }, currentStepState)
                    });
                }, status: hasBeenSubmitted ? status : undefined }, label));
        });
    }, [state]);
    return { gotoStep: gotoStep, navItems: navItems, state: state, statusUpdate: statusUpdate, submitStep: submitStep };
}

export { defaultReducer, useWizardState };
//# sourceMappingURL=useWizardState.esm.js.map
